import React from "react";
import "./FinanceFooter.scss";

const FinanceFooter = () => {
  return (
    <main className="finance-footer-main">
      <section className="finance-footer-section1">
        <div className="finance-footer-logo-container">
          <img src="../assets/img/finance/logo.png" alt="" />
        </div>
        <div className="finance-footer-email-container">
          <h2>Subscribe Newsletter</h2>
          <input type="email" placeholder="Email Address" />
          <button>
            Sign Up <span class="material-symbols-outlined">chevron_right</span>
          </button>
        </div>
      </section>
      <section className="finance-footer-section2">
        <div className="finance-footer-section2-left">
          <h2>
            Ready Discover More?<br></br> Contact Us Today!
          </h2>
          <p>No credit card requirement it’s full free for all</p>
          <input type="email" placeholder="Email Address" />
          <button>
            Sign Up Now{" "}
            <span class="material-symbols-outlined">chevron_right</span>
          </button>
        </div>
        <div className="finance-footer-section2-right">
          <div className="finance-footer-section2-right1">
            <h2>Services</h2>
            <p>Business Plan</p>
            <p>Growth Strategy</p>
            <p>Strategic planning</p>
            <p>Workflow Automation</p>
            <p>Lead Generation</p>
            <p>Financial Planning</p>
          </div>
          <div className="finance-footer-section2-right2">
            <h2>Locations</h2>
            <p>
              55 Main Street, 2nd block <br></br>Malborne, Australia
            </p>
            <h2>Contact</h2>
            <p>support@gmail.com</p>
            <h2>+880 (123) 456 88</h2>
          </div>
        </div>
      </section>
      <section className="finance-footer-section3">
        <p>
          Copyright ©2025, <a href="#">Business</a> All Rights Reserved
        </p>
        <div>
          <div className="finance-footer-icon-container">
            <div className="finance-footer-icon">
              <img src="../assets/img/finance/facebook-icon.webp" alt="" />
            </div>
            <div className="finance-footer-icon">
              <img src="../assets/img/finance/instagram-icon.webp" alt="" />
            </div>
            <div className="finance-footer-icon">
              <img src="../assets/img/finance/pinterest-icon.webp" alt="" />
            </div>
            <div className="finance-footer-icon">
              <img src="../assets/img/finance/x-logo.webp" alt="" />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default FinanceFooter;
